import { useContext, useEffect, useState } from "react";
import ViewerContext from "../../context/ViewerContext";

const SCENE_BASE_URL = "https://burnair-activities-prod.s3.eu-central-1.amazonaws.com/scenes";

function SceneLoader() {
  const { setLoadedFileDataList } = useContext(ViewerContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sceneSlug = urlParams.get("scene");

    if (sceneSlug) {
      // Delay to ensure DOM is ready
      const timer = setTimeout(() => {
        loadScene(sceneSlug);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const loadScene = async (slug) => {
    setLoading(true);

    // Show loader if available
    const loader = document.getElementById('map-loader');
    if (loader) loader.hidden = false;

    try {
      // Fetch scene.json manifest
      const manifestUrl = `${SCENE_BASE_URL}/${slug}/scene.json`;
      const manifestResponse = await fetch(manifestUrl);

      if (!manifestResponse.ok) {
        throw new Error(`Failed to load scene manifest: ${manifestResponse.statusText}`);
      }

      const sceneData = await manifestResponse.json();
      console.log(`Loading scene: ${sceneData.title} (${sceneData.files.length} files)`);

      // Fetch all IGC files in parallel
      const igcPromises = sceneData.files.map(async (filename) => {
        const fileUrl = `${SCENE_BASE_URL}/${slug}/${filename}`;
        const response = await fetch(fileUrl);

        if (!response.ok) {
          console.warn(`Failed to load ${filename}: ${response.statusText}`);
          return null;
        }

        const content = await response.text();

        // Create a File object to match the drag-and-drop flow
        return new File([content], filename, { type: 'text/plain' });
      });

      const files = await Promise.all(igcPromises);
      const validFiles = files.filter(file => file !== null);

      console.log(`Loaded ${validFiles.length} of ${sceneData.files.length} IGC files`);

      // Use existing file upload flow - everything will work normally!
      setLoadedFileDataList(validFiles);

    } catch (error) {
      console.error("Error loading scene:", error);
      alert(`Failed to load scene: ${error.message}`);
    } finally {
      setLoading(false);
      // Hide loader if available
      const loader = document.getElementById('map-loader');
      if (loader) loader.hidden = true;
    }
  };

  return null;
}

export default SceneLoader;
